import * as React from 'react';
import {connect} from 'react-redux';
import DownIcon from 'mdi-react/ChevronDownIcon';
import {DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown} from 'reactstrap';
import {RouteComponentProps, withRouter} from 'react-router';
import TopbarNavLink from './topbar-nav-link';
import TopbarNavCategory from '../../../../../theme/pages/_layout/topbar_with_navigation/tobar_nav/TopbarNavCategory';
import {Link} from 'react-router-dom';

interface TopbarNavProps {
    sidebar: any;
    dispatch: (action: any) => (any);
}

const mapStateToProps = (state) => {
    const stateProps = {
        sidebar: state.sidebar
    };
    return stateProps;
};

class TopbarNav extends React.PureComponent<TopbarNavProps & RouteComponentProps<any>, {}> {

    public render() {
        return (
            <nav className='topbar__nav'>
                <UncontrolledDropdown className='topbar__nav-dropdown'>
                    <DropdownToggle className='topbar__nav-dropdown-toggle'>
                        Avances de Venta
                        <DownIcon/>
                    </DropdownToggle>
                    <DropdownMenu className='topbar__nav-dropdown-menu dropdown__menu'>
                        <DropdownItem tag={'li'}>
                            <TopbarNavLink title='Comparativo Anual' route='/avances/anual'/>
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
                <Link className='topbar__nav-link' to='/coberturas'>Coberturas</Link>
                <UncontrolledDropdown className='topbar__nav-dropdown'>
                    <DropdownToggle className='topbar__nav-dropdown-toggle'>
                        Prioritarios
                        <DownIcon/>
                    </DropdownToggle>
                    <DropdownMenu className='topbar__nav-dropdown-menu dropdown__menu'>
                        <DropdownItem tag={'li'}>
                            <TopbarNavLink title='Gloria' route='/prioritarios/gloria'/>
                            <TopbarNavLink title='San Fernando' route='/prioritarios/sanfernando'/>
                            <TopbarNavLink title='Kimberly' route='/prioritarios/kimberly'/>
                            <TopbarNavLink title='Nexo' route='/prioritarios/nexo'/>
                            <TopbarNavLink title='Stanley' route='/prioritarios/stanley'/>
                            <TopbarNavLink title='Auren 2' route='/prioritarios/auren2'/>
                        </DropdownItem>
                        <DropdownItem divider={true}/>
                        <DropdownItem tag={'li'}>
                            <TopbarNavLink title='Configuración' route='/prioritarios/configuracion'/>
                            <TopbarNavLink title='Tienda Pago' route='/prioritarios/tiendapago'/>
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
                <Link className='topbar__nav-link' to='/rechazos'>Rechazos</Link>
                <UncontrolledDropdown className='topbar__nav-dropdown'>
                    <DropdownToggle className='topbar__nav-dropdown-toggle'>
                        Stock
                        <DownIcon/>
                    </DropdownToggle>
                    <DropdownMenu className='topbar__nav-dropdown-menu dropdown__menu'>
                        <DropdownItem tag={'li'}>
                            <TopbarNavLink title='Gloria' route='/stock/gloria'/>
                        </DropdownItem>
                        <DropdownItem tag={'li'}>
                            <TopbarNavLink title='Detallado' route='/stock/producto'/>
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
                <Link className='topbar__nav-link' to='/t2'>T2</Link>
                <UncontrolledDropdown className='topbar__nav-dropdown'>
                    <DropdownToggle className='topbar__nav-dropdown-toggle'>
                        Visicoolers
                        <DownIcon/>
                    </DropdownToggle>
                    <DropdownMenu className='topbar__nav-dropdown-menu dropdown__menu'>
                        <TopbarNavCategory title='Gloria'>
                            <TopbarNavLink title='Asignados' route='/visicoolers/gl/asignados'/>
                            <TopbarNavLink title='Modelos' route='/visicoolers/gl/modelos'/>
                            <TopbarNavLink title='Asignar' route='/visicoolers/gl/asignar'/>
                        </TopbarNavCategory>
                        <TopbarNavCategory title='San Fernando'>
                            <TopbarNavLink title='Asignados' route='/visicoolers/sf/asignados'/>
                            <TopbarNavLink title='Asignar' route='/visicoolers/sf/asignar'/>
                            <TopbarNavLink title='Cuotas' route='/visicoolers/sf/cuotas'/>
                        </TopbarNavCategory>
                    </DropdownMenu>
                </UncontrolledDropdown>
                <UncontrolledDropdown className='topbar__nav-dropdown'>
                    <DropdownToggle className='topbar__nav-dropdown-toggle'>
                        Celulares
                        <DownIcon/>
                    </DropdownToggle>
                    <DropdownMenu className='topbar__nav-dropdown-menu dropdown__menu'>
                        <DropdownItem tag={'li'}>
                            <TopbarNavLink title='Avance x Zonal' route='/celulares/zonales'/>
                        </DropdownItem>
                        <DropdownItem tag={'li'}>
                            <TopbarNavLink title='Avance x PDV' route='/celulares/pdvs'/>
                        </DropdownItem>
                        <DropdownItem tag={'li'}>
                            <TopbarNavLink title='Cargar data' route='/celulares/zonales/data'/>
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
            </nav>
        )
    }
}

export default withRouter(connect(mapStateToProps)(TopbarNav));


// WEBPACK FOOTER //
// ./src/components/common/layout/topbar_with_navigation/topbar_nav/topbar_nav.tsx